import React from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { PrimeIcons } from 'primereact/api';
import { classNames } from 'primereact/utils';
import { FormField } from '../../../components/FormField/FormField';
import { Organization } from '../../../types/organization';
import { OrgEmailSettingsFormState } from '../hooks/useOrgEmailSettingsForm';

interface Props {
  orgEmailSettings: OrgEmailSettingsFormState;
  organization: Organization | undefined;
  organizationLoading: boolean;
  userHasEditFeature: boolean;
}

export const OrgEmailSettingsSection = ({ orgEmailSettings, organization, organizationLoading, userHasEditFeature }: Props) => {
  return (
    <Card>
      <form
        className={classNames({
          'form-loading': organizationLoading || orgEmailSettings.isSaving,
        })}
        onSubmit={orgEmailSettings.handleSubmit}
        ref={orgEmailSettings.formRef}
      >
        <FormField fullWidth>
          <div className='email-settings-header'>
            <h4>Correo electrónico de la empresa</h4>
          </div>
        </FormField>
        <p className='org-email-settings-description'>
          No Gravity usará este correo electrónico para enviar correos electrónicos a los usuarios. Esto puede incluir
          invitaciones, notificaciones, promociones, etc. Se debe usar un dominio propio, no se puede usar un dominio como
          @gmail.com o hotmail.com.
        </p>
        {organization?.email && (
          <FormField
            elementId='email'
            labelTitle='Dirección de correo electrónico'
            error={orgEmailSettings.validationErrors?.emailLocalPart}
            required
          >
            <div className='p-inputgroup org-email-inputgroup'>
              <InputText
                placeholder='Correo electrónico de la empresa'
                id='email'
                className={classNames({ 'p-invalid': orgEmailSettings.validationErrors?.emailLocalPart })}
                value={orgEmailSettings.form?.emailLocalPart ?? ''}
                autoComplete='email'
                onChange={(e) => orgEmailSettings.handleLocalPartChange(e.target.value)}
                disabled={!userHasEditFeature}
              />
              <span className='p-inputgroup-addon'>{orgEmailSettings.form?.emailDomain}</span>
            </div>
          </FormField>
        )}
        <FormField></FormField>
        {userHasEditFeature && (
          <Button
            type='submit'
            disabled={!orgEmailSettings.hasChanged}
            className='pull-right pull-down'
            label='Guardar'
            icon={PrimeIcons.SAVE}
          />
        )}
      </form>
    </Card>
  );
};
